import { Form, Formik } from "formik";
import { useState } from "react";
import { object, string } from "yup";
import Button from "../../UI/Button";
import Callout from "../../UI/Callout";
import FormikSubmitButton from "../../UI/FormikSubmitButton";
import ModalDialog from "../../UI/ModalDialog";
// @ts-expect-error pure js
import TextInput from "../../UI/TextInput";
// @ts-expect-error pure js
import Checkbox from "../../UI/Checkbox";
// @ts-expect-error pure js
import { handleAPIError } from "../../../utils";
import type { PriorityAction } from "../../../models/priorityAction";
import type { SnoozeValues } from "../../../hooks/use-priority-actions";
import styles from "./PriorityActionForm.module.css";

interface SnoozeDialogProps {
  action: PriorityAction | null;
  onOpenChange: (open: boolean) => void;
  onSnooze: (actionId: number, values: SnoozeValues) => Promise<unknown>;
}

const VALIDATION_SCHEMA = object({
  remind_at: string().required("La date de rappel est requise"),
});

export default function SnoozeDialog({
  action,
  onOpenChange,
  onSnooze,
}: SnoozeDialogProps) {
  const [error, setError] = useState("");

  async function submit(values: SnoozeValues) {
    if (!action) {
      return;
    }
    setError("");
    try {
      await onSnooze(action.id, values);
      onOpenChange(false);
    } catch (err) {
      setError(handleAPIError(err));
    }
  }

  return (
    <Formik
      initialValues={{
        remind_at: action?.remind_at ?? "",
        remind_by_mail: action?.remind_by_mail ?? false,
      }}
      enableReinitialize={true}
      validationSchema={VALIDATION_SCHEMA}
      onSubmit={(values) =>
        submit({
          remind_at: values.remind_at,
          remind_by_mail: values.remind_by_mail,
        })
      }
    >
      {({ resetForm }) => (
        <ModalDialog
          size="xs"
          open={action !== null}
          header="Me le rappeler le"
          subtitle="L'action sera masquée jusqu'à la date choisie."
          onOpenChange={(nextOpen) => {
            if (!nextOpen) {
              resetForm();
              setError("");
            }
            onOpenChange(nextOpen);
          }}
        >
          <Form className={styles.form}>
            <TextInput
              type="date"
              label="Date de rappel"
              name="remind_at"
              marginForm=""
              mandatory
            />
            <Checkbox name="remind_by_mail">
              M'envoyer un mail de rappel
            </Checkbox>
            <div className={styles.actions}>
              {action?.remind_at && (
                <Button
                  type="button"
                  variant="secondary"
                  onClick={() =>
                    submit({ remind_at: null, remind_by_mail: false })
                  }
                >
                  Annuler le rappel
                </Button>
              )}
              <FormikSubmitButton>Valider</FormikSubmitButton>
            </div>
            <Callout variant="danger">{error}</Callout>
          </Form>
        </ModalDialog>
      )}
    </Formik>
  );
}
